<template>
  <transition name="slide-up">
    <div
      v-if="showBanner"
      class="cookie-notice-banner"
      role="dialog"
      aria-labelledby="cookie-notice-title"
      aria-describedby="cookie-notice-desc"
    >
      <div class="cookie-notice-content">
        <span class="cookie-icon">🍪</span>
        <div class="cookie-notice-text" id="cookie-notice-desc">
          We use cookies to improve your experience and analyze site traffic.
          By continuing to use this site, you accept our use of cookies.
          <router-link to="/privacy_policy" class="privacy-link">
            Learn more in our Privacy Policy
          </router-link>.
        </div>
        <button
          class="cookie-notice-button"
          @click="handleDismiss"
          aria-label="Dismiss cookie notice"
        >
          Got It
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CookieNoticeBanner',
  computed: {
    ...mapGetters('CookieNotice', ['showBanner'])
  },
  methods: {
    ...mapActions('CookieNotice', ['dismissBanner']),
    handleDismiss() {
      this.dismissBanner()
      this.trackAnalyticsEvent('Cookie Notice Dismissed')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";

.cookie-notice-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: $redico-inky-2;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  padding: 1.5rem 2rem;

  @include phone-down {
    padding: 1.2rem 1.5rem;
  }
}

.cookie-notice-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 1.5rem;

  @include phone-down {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
}

.cookie-icon {
  font-size: 2.4rem;
  flex-shrink: 0;

  @include phone-down {
    font-size: 2rem;
  }
}

.cookie-notice-text {
  flex: 1;
  font-family: Proxima Nova;
  font-size: 1.4rem;
  line-height: 1.5;
  color: #ffffff;
  text-align: left;

  @include phone-down {
    font-size: 1.2rem;
    text-align: center;
  }
}

.privacy-link {
  color: $pg-orange;
  text-decoration: underline;

  &:hover {
    color: lighten($pg-orange, 10%);
  }
}

.cookie-notice-button {
  background: $pg-orange;
  color: #ffffff;
  font-family: Proxima Nova;
  font-size: 1.4rem;
  font-weight: 700;
  padding: 1rem 2.4rem;
  border: none;
  border-radius: 0.4rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease;

  &:hover {
    background: lighten($pg-orange, 5%);
  }

  &:focus {
    outline: 2px solid $pg-orange;
    outline-offset: 2px;
  }

  @include phone-down {
    width: 100%;
    padding: 1.2rem;
  }
}

// Slide-up animation
.slide-up-enter-active {
  transition: transform 0.4s ease-out;
}

.slide-up-leave-active {
  transition: transform 0.3s ease-in;
}

.slide-up-enter {
  transform: translateY(100%);
}

.slide-up-leave-to {
  transform: translateY(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/cookie-notice/CookieNoticeBanner.vue